import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import ButtonDivisionSection from "../ButtonDivisionSection/ButtonDivisionSection";
import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import {RouteInfo} from "../../route/RouteHelper";
import React, {useState} from "react";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import VideoDetailBasicInformation from "./VideoDetailBasicInformation";
import VideoDetailThumbnail from "./VideoDeatailThumbnail";
import VideoDetailSeoDetail from "./VideoDetailSeoDetail";

import {useNavigate} from "react-router-dom";

const VideosDetail = () => {

    const [tabSelectedValue, setTabSelectedValue] = useState(videosTabTypes.basicInformation.id)

    const navigate = useNavigate()

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    function handleBackToList() {
        navigate(RouteInfo.MultiMediaList.globalUrl)
    }

    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <ButtonDivisionSection>
                    <RaikoBreadcrumb
                        className={css`flex-grow: 1`}
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "ویدیو ها",
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                "جزئیات ویدیو",
                                ""
                            ),
                        ]}/>
                    <ButtonSecondaryRaiko label={"بازگشت"} onClick={handleBackToList}/>
                </ButtonDivisionSection>
                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`
                      border-color: var(--header-border-bottom-color) !important;
                    `}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                 label={videosTabTypes.basicInformation.title}
                                 value={videosTabTypes.basicInformation.id}
                            /><Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                                   label={videosTabTypes.thumbnail.title}
                                   value={videosTabTypes.thumbnail.id}
                        /><Tab icon={<div id="tabIcon" className={"ic-location"}/>} iconPosition="start"
                               label={videosTabTypes.seoDetail.title}
                               value={videosTabTypes.seoDetail.id}
                        />
                        </TabList>
                    </Box>
                    <TabPanel value={videosTabTypes.basicInformation.id}>
                        <VideoDetailBasicInformation/>
                    </TabPanel>
                    <TabPanel value={videosTabTypes.thumbnail.id}>
                        <VideoDetailThumbnail/>
                    </TabPanel>
                    <TabPanel value={videosTabTypes.seoDetail.id}>
                        <VideoDetailSeoDetail/>
                    </TabPanel>

                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
export default VideosDetail;
const videosTabTypes = {
    basicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
    thumbnail: {
        id: "thumbnail",
        title: "تصویر شاخص",
    },
    seoDetail: {
        id: "detail",
        title: "بهینه سازی موتور جستجو"
    }
}